import React from 'react'
import CommonHeader from './commonheader/CommonHeader'
import Footer from './Footer'

import CreativeLab from './our-story/CreativeLab'
import EmbroideryUnit from './our-story/EmbroideryUnit'
import TailoringUnit from './our-story/TailoringUnit'
import QualityControl from './our-story/QualityControl'

const OurStory = () => {
  return (
    <div>
      <CommonHeader />

      <div id="creative-lab">
        <CreativeLab />
      </div>

      <div id="embroidery-unit">
        <EmbroideryUnit />
      </div>

      <div id="tailoring-unit">
        <TailoringUnit />
      </div>

      <div id="quality-control">
        <QualityControl />
      </div>

      <Footer />
    </div>
  )
}

export default OurStory
